(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-video-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('well-homepage-video')) {
    customElements.define('well-homepage-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('button');
        const template = this.querySelector('template');
        if (!button || !template) return;
        this.initialized = true;
        button.addEventListener('click', () => {
          const frame = template.content.querySelector('iframe').cloneNode(true);
          const url = new URL(frame.getAttribute('src'), document.baseURI);
          url.searchParams.set('autoplay', '1');
          frame.setAttribute('src', url.toString());
          this.replaceChildren(frame);
          frame.focus();
        }, { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["well-custom-behavior"]) return;
  try {
    
  function initializeWellCustomizations() {
    document.querySelectorAll('.tab-container').forEach((container) => {
      if (container.dataset.wellInitialized) return;
      container.dataset.wellInitialized = 'true';
      const tabs = [...container.querySelectorAll('ul.tabs li')];
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'button');
        tab.tabIndex = 0;
        const activate = () => {
          tabs.forEach((item) => item.classList.toggle('active', item === tab));
          container.querySelectorAll('.tab_content').forEach((panel) => {
            panel.style.display = panel.id === tab.getAttribute('rel') ? 'block' : 'none';
          });
          container.querySelectorAll('.tab_drawer_heading').forEach((item) => item.classList.toggle('d_active', item.getAttribute('rel') === tab.getAttribute('rel')));
        };
        tab.addEventListener('click', activate);
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); }
        });
        if (index === 0) activate();
      });
    });
    if (window.jQuery && jQuery.fn.slick) {
      jQuery('.customer-slider .customer-list').not('.slick-initialized').slick({dots:false,infinite:true,speed:300,slidesToShow:2,slidesToScroll:1,responsive:[{breakpoint:768,settings:{slidesToShow:1,slidesToScroll:1}}]});
    }
    document.querySelectorAll('#accordion > li > h3').forEach((heading) => {
      if (heading.dataset.wellInitialized) return;
      heading.dataset.wellInitialized = 'true';
      heading.tabIndex = 0;
      heading.setAttribute('role', 'button');
      const toggle = () => {
        const item = heading.parentElement;
        const open = !item.classList.contains('active');
        item.parentElement.querySelectorAll(':scope > li').forEach((other) => {
          other.classList.remove('active');
          const panel = other.querySelector(':scope > ul');
          if (panel) panel.style.display = 'none';
        });
        item.classList.toggle('active', open);
        heading.setAttribute('aria-expanded', String(open));
        if (heading.nextElementSibling) heading.nextElementSibling.style.display = open ? 'block' : 'none';
      };
      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();toggle();}
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWellCustomizations);
  else initializeWellCustomizations();
  document.addEventListener('shopify:section:load', initializeWellCustomizations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["well-product-tabs"]) return;
  try {
    
  function activateWellTab(tab) {
    const wrapper = tab.closest('.well-tabs');
    wrapper.querySelectorAll('[role="tab"]').forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
    });
  }
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.well-tabs [role="tab"]');
    if (tab) activateWellTab(tab);
    const reviewsLink = event.target.closest('[data-oke-reviews-product-listing-rating] a');
    if (reviewsLink) {
      const reviewsTab = document.querySelector('.well-tabs [role="tab"][id^="WellReviewsTab"]');
      if (reviewsTab) activateWellTab(reviewsTab);
    }
  });
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('.well-tabs [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.closest('.well-tabs').querySelectorAll('[role="tab"]')];
    const target = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[tabs.length - 1] : tabs[(tabs.indexOf(tab) + 1) % tabs.length];
    activateWellTab(target);
    target.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
